<template>
  <div class="informationDetail">
    <el-dialog :visible.sync="visible" :show-close="false" width="670px">
      <div class="content">
        <div class="main">
          <div class="top">
            <div class="top_left">
              <el-avatar :size="40" :src="$oss + detailData.authorAvatar" />
              <div class="userInfo">
                <div class="userInfo_t">
                  <div>{{ detailData.authorName }}</div>
                  <AuthIcon />
                </div>
                <div class="userInfo_b">{{ renderTime(detailData.updatedAt) }}</div>
              </div>
            </div>
            <div class="top_right">
              <div>
                <span>评论：</span>
                {{ detailData.commentCount }}
              </div>
              <div>
                <span>浏览：</span>
                {{ detailData.viewCount }}
              </div>
            </div>
          </div>
          <div class="text">
            {{ detailData.content }}
          </div>
          <div class="imgBox">
            <imageBox :url="detailData.url" v-if="detailData.type === 1" type="detail" />
            <videoBox
              v-else-if="detailData.type === 2"
              :imgUrl="detailData.coverUrl"
              type="detail"
              :url="detailData.url"
            />
          </div>
          <commentBox />
          <commentinput />
        </div>
        <div class="desc">
          内容由用户自主上传，其他用户使用时请自行判断其合法性与真实性，由此引发的损失或纠纷，平台不担责。
        </div>
        <img
          src="@/assets/image/close2.webp"
          class="close"
          alt=""
          srcset=""
          @click="onClose"
        />
      </div>
    </el-dialog>
    <div class="main">
      <div class="content">
        <div class="masBox"></div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthIcon from "@/components/AuthIcon/index.vue";
import { mapState } from "vuex";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/zh-cn";
import imageBox from "@/views/Information/components/imageBox.vue";
import videoBox from "@/views/Information/components/videoBox.vue";
import commentBox from "./commentBox.vue";
import commentinput from "./commentinput.vue";
export default {
  components: { AuthIcon, imageBox, videoBox, commentBox, commentinput },
  data() {
    return {};
  },
  created() {},
  computed: {
    ...mapState("information", ["detailData", "messageId"]),
    visible: {
      get() {
        return this.$store.state.information.detailVisible;
      },
      set(val) {
        if (val) {
          this.$store.dispatch("information/detailOnShow");
        } else {
          this.$store.dispatch("information/detailOnClose");
        }
      },
    },
  },
  methods: {
    onClose() {
      this.visible = false;
    },
    renderTime(time) {
      dayjs.locale("zh-cn");
      dayjs.extend(relativeTime);
      const timestamp = time * 1000; // 转换为毫秒
      const fromNow = dayjs(timestamp).fromNow();
      return fromNow;
    },
  },
};
</script>

<style scoped lang="scss">
.informationDetail {
  @include popupNo;
}
.content {
  width: 670px;
  background-size: 100% auto;
  position: relative;

  .main {
    height: 800px;
    overflow-y: auto;
    background-color: #ffffff;
    border-radius: 6px;
    position: relative;
    display: flex;
    flex-direction: column;
    .top {
      flex-shrink: 0;
      height: 90px;
      display: flex;
      align-items: center;
      padding: 0 30px;
      justify-content: space-between;
      position: sticky;
      top: 0;
      z-index: 9;
      background-color: #ffffff;
      &_left {
        display: flex;
        gap: 8px;
        .avatar {
          width: 40px;
          height: 40px;
          border-radius: 100px;
          background-color: aliceblue;
        }
        .userInfo {
          display: flex;
          flex-direction: column;
          justify-content: center;
          gap: 4px;
          &_t {
            font-size: 14px;
            color: #3d3d3d;
            display: flex;
            gap: 6px;
            align-items: center;
          }
          &_b {
            color: #999999;
            font-size: 12px;
          }
        }
      }
      &_right {
        display: flex;
        font-size: 14px;
        color: #666666;
        gap: 20px;
        span {
          color: #999999;
        }
      }
    }
    .text {
      padding: 0 30px;
      font-size: 14px;
      font-weight: normal;
      line-height: 24px;
      font-variation-settings: "opsz" auto;
      color: #262626;
    }
    .imgBox {
      margin-top: 8px;
      padding: 0 30px;
    }
  }
  .close {
    width: 28px;
    height: 28px;
    position: absolute;
    bottom: -55px;
    z-index: 10;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
  }
  .desc {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    font-size: 10px;
    line-height: 10px;
    color: #ffffff;
    opacity: 0.5;
    bottom: -20px;
    width: 670px;
    text-align: center;
  }
}
</style>
